import React from 'react'

import Box from 'components_new/atoms/Box'
import StepAtom from 'components_new/atoms/Stepper/Step'
import StepLabel from 'components_new/atoms/Stepper/StepLabel'
import Stepper from 'components_new/atoms/Stepper'

import SearchField from 'components_new/molecules/SearchField'

import { ESourceStep, getStepMeta } from './lib'

interface HeroProps {
  activeStep: number
  search: string
  selected: boolean
  setSearch: (value: string) => void
  steps: ESourceStep[]
}

const Hero = (props: HeroProps) => {
  const { activeStep, search, selected, setSearch, steps } = props

  if (selected) {
    if (steps.length <= 1) {
      return null
    }

    return (
      <Stepper activeStep={activeStep}>
        {steps.map((step) => (
          <StepAtom key={step}>
            <StepLabel>{getStepMeta(step).title}</StepLabel>
          </StepAtom>
        ))}
      </Stepper>
    )
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <SearchField
        onClear={() => setSearch('')}
        onSearch={(value) => setSearch(value)}
        placeholder="Sök efter datakälla"
        size="small"
        value={search}
      />
    </Box>
  )
}

export default Hero
